export default {
    en: {
        intro_login: "Login",
        intro_free_use: "Try PM AutoTwin for Free",
        intro_try_demo: "Try Demo",
        intro_contact_sales: "Contact Sales"
    },
    ko: {
        intro_login: "로그인",
        intro_free_use: "PM AutoTwin 무료로 사용하기",
        intro_try_demo: "Try Demo",
        intro_contact_sales: "영업팀 문의하기"
    },
    ja: {
        intro_login: "ログイン",
        intro_free_use: "PM AutoTwinを無料で試す",
        intro_try_demo: "デモを試す",
        intro_contact_sales: "営業チームに問い合わせ"
    }
};
